import { render } from "./RuiFooter.vue?vue&type=template&id=003b4645&scoped=true"
import script from "./RuiFooter.vue?vue&type=script&lang=ts"
export * from "./RuiFooter.vue?vue&type=script&lang=ts"

import "./RuiFooter.vue?vue&type=style&index=0&id=003b4645&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-003b4645"

export default script